async function fetchDoc(firebase, path) {
  const docSnap = await firebase.firestore().doc(path).get();
  if (!docSnap.exists) return null;
  return { uid: docSnap.id, ...docSnap.data() };
}

async function fetchCollection(firebase, path) {
  const snap = await firebase.firestore().collection(path).get();
  return snap.docs.map((item) => ({ uid: item.id, ...item.data() }));
}

module.exports = {
  fetchCollection,
  fetchDoc,
};
